import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[required]'
})
export class LabelRequiredDirective implements OnInit {

    @Input() required: boolean = true;

    constructor(private renderer: Renderer2, private el: ElementRef) {}

    ngOnInit() {
        if(this.required === false) {
            return;
        }
        const parent = this.renderer.parentNode(this.el.nativeElement);

        if (parent.getElementsByClassName('label').length && !parent.getElementsByClassName('required-asterisk').length) {
            parent.getElementsByClassName('label')[0].innerHTML += '<span class="required-asterisk">*</span>';
        }

        if (parent.getElementsByTagName('h3').length && !parent.getElementsByClassName('required-asterisk').length) {
            parent.getElementsByTagName('h3')[0].innerHTML += '<span class="required-asterisk">*</span>';
        }
    }
}
